import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@src/ui/select";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import DeprecatedIcon from "@src/deprecatedDesignSystem/components/DeprecatedIcon";
import { deprecatedTones } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import { AiOrgContextFragment } from "@src/hooks/useBranding.generated";
import Spacer from "../ui/Spacer";
import Text from "@src/ui/text";

const ComposerBrandSelector = ({
  brandSelectOptions,
  onSelectValueChange,
  selectedBrandItem,
  defaultValue,
}: {
  brandSelectOptions: BrandSelectOption[];
  onSelectValueChange: (value: string) => void;
  selectedBrandItem?: BrandSelectOption;
  defaultValue: string;
}): JSX.Element => {
  return (
    <>
      <Select defaultValue={defaultValue} onValueChange={onSelectValueChange}>
        <SelectTrigger className="flex-1 self-stretch pl-2">
          <div className="flex flex-1 items-center gap-2">
            {selectedBrandItem?.logoUrl ? (
              <div
                style={{
                  height: 20,
                  width: 20,
                  background: `url(${selectedBrandItem.logoUrl}) lightgray 50% / cover no-repeat`,
                  borderRadius: 20,
                }}
              />
            ) : (
              <DeprecatedIcon
                type="registered-trademark"
                iconSize={20}
                containerSize={20}
                color={deprecatedTones.gray10}
              />
            )}
            <Text
              type="P2"
              ellipsis
              ellipsisParentFlexDirection="row"
              className="text-start"
            >
              {selectedBrandItem?.name}
            </Text>
            <Spacer size={4} />
          </div>
        </SelectTrigger>
        <SelectContent
          style={{
            zIndex: 603,
          }}
        >
          {brandSelectOptions.map((option) => (
            <SelectItem
              key={option.aiOrgContextId}
              value={option.aiOrgContextId}
            >
              <BrandSelectOptionItem brandSelectOption={option} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  );
};
export default ComposerBrandSelector;

export const BrandSelectOptionItem = ({
  brandSelectOption,
}: {
  brandSelectOption: BrandSelectOption;
}): JSX.Element => {
  return (
    <AutoLayout
      flex={1}
      direction="horizontal"
      spaceBetweenItems={8}
      alignmentVertical="center"
    >
      <div style={{ borderRadius: "6.857px" }}>
        {brandSelectOption.logoUrl ? (
          <div
            style={{
              height: 24,
              width: 24,
              background: `url(${brandSelectOption.logoUrl}) lightgray 50% / cover no-repeat`,
              borderRadius: 24,
            }}
          />
        ) : (
          <DeprecatedIcon
            type="registered-trademark"
            iconSize={24}
            containerSize={24}
            color={deprecatedTones.gray10}
          />
        )}
      </div>
      <div>{brandSelectOption.name}</div>
    </AutoLayout>
  );
};

export type BrandSelectOption = {
  name: string;
  aiOrgContextId: string;
  logoUrl: string;
  aiOrgContext: AiOrgContextFragment;
  brandDetailsId: string;
};
